import { Component } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ToasterService } from 'angular5-toaster';
import { TramApiService } from "../../tram-api.service";
import { StorageService } from "../../storage.service";
import { passwordMatchValidator } from "../passwordMatchValidator";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
    selector: 'registration',
    templateUrl: 'registration.component.html',
    styleUrls: ['account.scss']
})
export class RegistrationComponent {
    registrationForm: FormGroup;

    isAuthenticated: boolean;

    constructor(
        public toaster: ToasterService,
        private api: TramApiService,
        private storage: StorageService,
        private formBuilder: FormBuilder) {
        storage.isSensitiveDataExist.subscribe(v => {
            if (this.isAuthenticated === v)
                return;

            this.isAuthenticated = v;

            if (!this.isAuthenticated) {
                if (this.registrationForm)
                    this.registrationForm.reset();
            }
        });
    }

    ngOnInit() {
        this.registrationForm = this.formBuilder.group({
            email: [null, [Validators.required, Validators.email]],
            password: [null, Validators.required],
            confirmation: [null, Validators.required],
            isAgreed: [null, Validators.requiredTrue]
        }, { validator: passwordMatchValidator });
    }

    onSubmit() {
        if (!this.registrationForm.valid)
            return;

        this.api.register(this.registrationForm.value.email, this.registrationForm.value.password)
            .catch(error => {
                if (error instanceof HttpErrorResponse) {
                    this.toaster.pop('error', null, error.statusText);
                } else {
                    this.toaster.pop('error', null, error);
                }
            });
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/account/registration.component.ts